import angular from 'angular';

angular.module('app.core').factory('Attribut', Attribut);

export default class Attribut {

    constructor(data, order) {
        this.id = data.id;
        this.order = order;
        this.name = data.name;
        this.path = data.path;
        this.type = data.type;
        this.labels = data.labels;
        this.display = data.display;
        this.filter = data.filter;
        this.indexed = data.indexed;
        if (data.labels) {
            data.labels.some(label => {
                if (label.lang.toLowerCase() === 'fr' && label.text !== '') {
                    this.name = label.text;
                    return true;
                }
            })
        }
    }


}
